import { HttpClient, HttpEvent, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

export interface OutboundAttributeFilter {
  key: string;
  value: string;
}

export interface OutboundAttributePayload {
  id?: number;
  outboundTypeId: number;
  attributeName: string;
  inputType: string;
  categoryId: number | null;
  required: boolean;
  status: number;
}

@Injectable({
  providedIn: 'root'
})
export class masterService {

  getOutboundAttributesByTypeId(outboundTypeId: number) {
    const url = `${environment.New_BASE_DOMAIN}ams-service/outbound/attrs/getByOutboundTypeId?outboundTypeId=${outboundTypeId}`;
    return this.api.get(url);
  }

  addOrUpdateOutboundAttribute(payload: OutboundAttributePayload) {
    const url = `${environment.New_BASE_DOMAIN}ams-service/outbound/attrs/addOrUpdate`;
    return this.api.post(url, payload);
  }

  getOutboundAttributeInfo(filters: OutboundAttributeFilter[], pageNumber: number, pageSize: number, sortingColumn: string, direction: 'ASC' | 'DESC') {
    const url = `${environment.New_BASE_DOMAIN}ams-service/outbound/attrs/getOutboundAttributeInfo` +
      `?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${encodeURIComponent(sortingColumn)}&direction=${direction}`;
    return this.api.post(url, filters);
  }

  constructor(private api : ApiService,private http: HttpClient) { 
  }
getVendorInfo(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ams-service/vendor/getVendorInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
} 

  getUsers(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ams-service/user/getUsers?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  } 

  getAmsUsers(formData: any[] = [], pageNumber: number = 0, pageSize: number = 100) {
    const url = `${environment.New_BASE_DOMAIN}ams-service/user/getUsers?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    return this.api.post(url, formData);
  }
  
    getRoleMappingList(){
    const url = `${environment.New_BASE_DOMAIN}ams-service/access/getRoles`;
    return this.api.get(url);
  } 

  addVendorAndEmployee(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'auth-service/auth/createUser')
    return this.api.post(url,formData);
  }
  updateUser(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'ams-service/user/addOrupdate')
    return this.api.post(url,formData);
  }
  createAccount(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'account-service/config/createAccount')
    return this.api.post(url,formData);
  }
  updateAccount(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'account-service/config/updateAccount')
    return this.api.put(url,formData);
  }
  
  
  getAccounts(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}ams-service/account/getAccountInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }
  
  getAccountMappings(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/info/getAccountMappings?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
    return this.api.post(url,formData);
  }

  addOrUpdateAccountMapping(formData:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/config/addOrUpdateAccountMapping`;
    return this.api.post(url,formData);
  }

quickCodeCategory(){
  const url = (environment.New_BASE_DOMAIN + '/ams-service/master/getAllMasterCategory')
  return this.api.get(url);
}

quickCodeList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ams-service/master/getQuickCodes?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

addQuickCode(formData:any){
    const url = (environment.New_BASE_DOMAIN + '/ams-service/master/addOrUpdateQuickCode')
    return this.api.post(url,formData);
}

employeesList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/employee/getEmployee?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
addOrUpdateEmployee(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/lms-service/employee/addOrUpdateEmployee')
  return this.api.post(url,formData);
}
getQuickCodeListByCategoryId(ids:any){
  let url = `${environment.New_BASE_DOMAIN}ams-service/master/getQuickCodeListByCategoryId`
  if (ids) {
    url += `?categoryId=${ids}`;
  }
  return this.api.get(url);
}





createWarehouse(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'warehouse-service/config/createWarehouse')
  return this.api.post(url,formData);
}
updateWarehouse(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'warehouse-service/config/updateWarehouse')
  return this.api.put(url,formData);
}
getWarehouseByFilter(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}warehouse-service/info/getWarehouseByFilter?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

upload(file: File): Observable<HttpEvent<any>> {
  var url :any
  const formData: FormData = new FormData();
  formData.append('file', file);
  const headers = new HttpHeaders({
    'VER': '1',
    'DEVICE-TYPE':'Web'
  });
  // headers.append('Content-Type', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
  url = `${environment.New_BASE_DOMAIN}ams-utils-service/uploads/uploadFiles`;

  const req = new HttpRequest('POST', url, formData, {
    headers,
    reportProgress: true,
    responseType: 'json'
  });
  return this.http.request(req);
}

approvalAddOrUpdate(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/lms-service/approval/addOrUpdate')
  return this.api.post(url,formData);
}
getApprovalMatrices(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/approval/getApprovalMatrices?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
deleteApprovalMatrices(id:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/approvalMatrices/deleteApprovalMatrices?id=${id}`
  return this.api.delete(url);
}
bulkApprovalMatrices(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/lms-service/approval/addOrUpdate')
  return this.api.post(url,formData);
}

getRevenueAttributes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/revenue/getRevenueAttributes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
bulkAddOrUpdateAttribute(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'lms-service/revenue/bulkAddOrUpdateAttribute')
  return this.api.post(url,formData);
}

getExpenseAttributes(formData:any,pageNumber:any,pageSize:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/expense/getExpenseAttributes?pageNumber=${pageNumber}&pageSize=${pageSize}`;
  return this.api.post(url,formData);
}
expensesBulkAddOrUpdateAttribute(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'lms-service/expense/bulkAddOrUpdateAttribute')
  return this.api.post(url,formData);
}
isInvoiceNumberExist(invoiceNumber:any,vendorId:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/invoice/isInvoiceNumberExist?invoiceNumber=${invoiceNumber}&vendorId=${vendorId}`;
  return this.api.get(url);
} 

 addUser(formData:any){
    const url = (environment.New_BASE_DOMAIN + 'lms-service/user/add')
    return this.api.post(url,formData);
  }
  getStatus(){
  const url = `${environment.New_BASE_DOMAIN}lms-service/master/getMasterStatus`;
  return this.api.get(url);
}


getWarehouseList(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ams-service/warehouse/getWarehouses?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
addOrUpdateWarehouse(formData:any){
  const url = `${environment.New_BASE_DOMAIN}ams-service/warehouse/addOrUpdate`;
  return this.api.post(url,formData);
}

getCustomer(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ams-service/account/getAccountInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
addOrUpdateCustomer(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ams-service/account/addOrUpdate')
  return this.api.post(url,formData);
}
getMappingInfo(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ams-service/accountWarehouseMapping/getAccountWarehouseMapping?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
addOrUpdateMapping(formData:any){
  const url = (environment.New_BASE_DOMAIN + 'ams-service/accountWarehouseMapping/addOrUpdate')
  return this.api.post(url,formData);
}
addOrUpdateAsset(formData: any) {
  const url = `${environment.New_BASE_DOMAIN}ams-service/asset/addOrUpdate`;
  return this.api.post(url, formData);
}

getAssetInfo(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}ams-service/asset/getAssetInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

/** Returns the inventory totals grouped by account, warehouse and product. */
getAssetProductQuantity(formData: any[], pageNumber: number, pageSize: number, sortingCol: string, direction: 'ASC' | 'DESC') {
  const url = `${environment.New_BASE_DOMAIN}ams-service/asset/getAssetProductQuantity?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${encodeURIComponent(sortingCol)}&direction=${direction}`;
  return this.api.post(url, formData);
}

addOrUpdateProduct(formData: any) {
  const url = `${environment.New_BASE_DOMAIN}ams-service/product/addOrUpdate`;
  return this.api.post(url, formData);
}

getProductInfo(formData: any, pageNumber: number, pageSize: number, sortingCol: string, direction: 'ASC' | 'DESC') {
  const url = `${environment.New_BASE_DOMAIN}ams-service/product/getProductInfo?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${encodeURIComponent(sortingCol)}&direction=${direction}`;
  return this.api.post(url, formData);
}

getMenuList(roleId: number = 1) {
  const url = `${environment.New_BASE_DOMAIN}ams-service/access/getSideMenuPermissions?roleId=${roleId}`;
  return this.api.get(url);
}

addOrUpdateMenu(formData: any) {
  const url = `${environment.New_BASE_DOMAIN}ams-service/module/addOrUpdate`;
  return this.api.post(url, formData);
}
addOrUpdateVendor(formData:any){
  const url = (environment.New_BASE_DOMAIN + '/ams-service/vendor/addOrUpdate')
  return this.api.post(url,formData);
}
getOrganization(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/account/getOrganization?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}
getComponents(formData:any,pageNumber:any,pageSize:any,sortingCol:any, direction:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/component/getComponents?pageNumber=${pageNumber}&pageSize=${pageSize}&sortingColumn=${sortingCol}&direction=${direction}`;
  return this.api.post(url,formData);
}

addOrUpdateProfessionalTaxWithSlab(formData:any){
  const url = `${environment.New_BASE_DOMAIN}lms-service/wage-master/addOrUpdateProfessionalTaxWithSlab`;
  return this.api.post(url,formData);
}


getUser(mobile:any,email:any,username:any){
  const baseUrl = `${environment.New_BASE_DOMAIN}ams-service/user/getUser`;
  let params: string[] = [];
  if (mobile) {
    params.push(`mobile=${mobile}`);
  }
  if (email) {
    params.push(`email=${email}`);
  }
  if (username) {
    params.push(`username=${username}`);
  }
  if (params.length === 0) {
    return null;  
  }
  const finalUrl = `${baseUrl}?${params.join('&')}`;
  console.log(finalUrl,'finalUrl')
  // const url = `${environment.BASE_DOMAIN}account-service/user/getUser?mobile=${mobile}&email=${email}&username=${username}`
  return this.api.get(finalUrl);
}
}
